import { NextPage } from 'next';
import React from 'react';
import Meta from './meta';
import Page from './Page';
const NotFound404: NextPage = (): React.ReactElement => <>
    <Page data-sentry-element="Page" data-sentry-source-file="index.tsx" />

    <Meta data-sentry-element="Meta" data-sentry-source-file="index.tsx" />
  </>;
export default NotFound404;